import St from "../modules/reactApp/src/config/core/BrowserStorage";
import { fetchApi } from "../modules/reactApp/src/config/core/Api";
import { AxiosResponse } from "axios";
let t = window.INITIAL_DATA.TRANSLATIONS;

class InstagramRedirect {
  code: string;
  redirectUrl: string;

  constructor() {
    this.code = "";
    this.handleRedirect = this.handleRedirect.bind(this);
    this.setCode = this.setCode.bind(this);
    this.getToken = this.getToken.bind(this);
    document.addEventListener("DOMContentLoaded", this.handleRedirect);
  }

  handleRedirect() {
    if (this.setCode()) {
      this.getToken(this.code);
    }
  }

  getToken(code: string) {
    fetchApi({
      method: "POST",
      fullUrl: `${window.location.origin}${window.woocommerce_params.ajax_url}?action=instagram_authentication`,
      data: {
        clientId: "275739560352240",
        redirectUri: `${window.location.origin}/instagram-authenticator/`,
        code: code,
      },
    })
      .then((r: AxiosResponse<any>) => {
        if (r.status == 200) {
          St.setIgAuthData(JSON.stringify(r.data));
          window.opener.instagramAuthenticationCheck();
          window.close();
        }
      })
      .catch((e) => {
        window.globalToast({
          type: "error",
          title: t.error,
          description: t.instagram_auth_fail,
          timeOut: 5000,
        });
      })
      .finally();
  }

  setCode(): boolean {
    let params = new URLSearchParams(window.location.search);
    let code = params.get("code");

    if (code) {
      this.code = code;
      return true;
    } else {
      return false;
    }
  }
}

export default InstagramRedirect;
